import { createContext, useContext } from 'react';
import type { Palette } from './ThemeContext';

type Theme = 'light' | 'dark';

interface ThemeContextValue {
  theme: Theme;
  palette: Palette;
  toggleTheme: () => void;
  setPalette: (p: Palette) => void;
}

export const ThemeContext = createContext<ThemeContextValue>({
  theme: 'light',
  palette: 'sunset',
  toggleTheme: () => {},
  setPalette: () => {},
});

export function useThemeContext() {
  return useContext(ThemeContext);
}
